import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
export const ActionView = (props) => {
    return (React.createElement(ActionViewWrapperStyled, null,
        React.createElement(ActionViewStyled, null, props.children)));
};
export default ActionView;
const PADDING = 10;
const ActionViewWrapperStyled = styled.div `
  margin-top: -${THEME.GRID_SPACING}px;
  position: absolute;
  left: 75%;
  padding: ${PADDING}px;
  width: 25%;
`;
const ActionViewStyled = styled.div `
  height: ${(props) => `calc(100vh - ${props.withSubMenu
    ? THEME.NAV_TOP_HEIGHT + THEME.SUB_MENU_HEIGHT + PADDING * 2
    : THEME.NAV_TOP_HEIGHT + PADDING * 2}px);`}
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  background-color: ${THEME.COLOR_SECONDARY};
  border-radius: 3px;
`;
//# sourceMappingURL=ActionView.js.map